"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setCookie(cookieName, cookieValue, daysTillExpires) {
    var date = new Date();
    date.setTime(date.getTime() + (daysTillExpires * 24 * 60 * 60 * 1000));
    // tslint:disable-next-line: prefer-template
    var expires = 'expires=' + date.toUTCString();
    // tslint:disable-next-line: prefer-template
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/;secure;samesite=none';
}
exports.setCookie = setCookie;
function getCookie(cookieName) {
    // tslint:disable-next-line: prefer-template
    var name = cookieName + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
exports.getCookie = getCookie;
